import ASSET__arrowDown from "../../packages/cross/assets/img/arrowDown.svg";
import ASSET__blob from "../../packages/cross/assets/img/blob.svg";
import ASSET__brands__anw__background from "../../packages/cross/assets/img/brands/anw/background.png";
import ASSET__brands__anw__favicon from "../../packages/cross/assets/img/brands/anw/favicon.png";
import ASSET__brands__visonum__favicon from "../../packages/cross/assets/img/brands/visonum/favicon.png";
import ASSET__brands__vodafone__favicon from "../../packages/cross/assets/img/brands/vodafone/favicon.png";
import ASSET__error from "../../packages/cross/assets/img/error.svg";
import ASSET__initDownload from "../../packages/cross/assets/img/initDownload.svg";
import ASSET__initPing from "../../packages/cross/assets/img/initPing.svg";
import ASSET__initUpload from "../../packages/cross/assets/img/initUpload.svg";
import ASSET__letsGetReady from "../../packages/cross/assets/img/letsGetReady.svg";
import ASSET__loading from "../../packages/cross/assets/img/loading.svg";
import ASSET__logo from "../../packages/cross/assets/img/logo.svg";
import ASSET__logos__speedAnalyzerBig from "../../packages/cross/assets/img/logos/speedAnalyzerBig.svg";
import ASSET__logos__speedAnalyzerSmall from "../../packages/cross/assets/img/logos/speedAnalyzerSmall.svg";
import ASSET__logos__speedAnalyzerSmallGray from "../../packages/cross/assets/img/logos/speedAnalyzerSmallGray.svg";
import ASSET__menu__bottomBar from "../../packages/cross/assets/img/menu/bottomBar.svg";
import ASSET__ok from "../../packages/cross/assets/img/ok.svg";
import ASSET__shield from "../../packages/cross/assets/img/shield.svg";
import ASSET__visonum from "../../packages/cross/assets/img/visonum.svg";
import ASSET__visonumLogo from "../../packages/cross/assets/img/visonumLogo.svg";
import ASSET__warning from "../../packages/cross/assets/img/warning.svg";
import ASSET__wave from "../../packages/cross/assets/img/wave.png";
import ASSET__waveGray from "../../packages/cross/assets/img/waveGray.png";

const getSrc = (val) => (val.src === undefined ? val : val.src);

export const imgs = {
  arrowDown: getSrc(ASSET__arrowDown),
  blob: getSrc(ASSET__blob),
  brands: {
    anw: {
      background: getSrc(ASSET__brands__anw__background),
      favicon: getSrc(ASSET__brands__anw__favicon),
    },
    visonum: { favicon: getSrc(ASSET__brands__visonum__favicon) },
    vodafone: { favicon: getSrc(ASSET__brands__vodafone__favicon) },
  },
  error: getSrc(ASSET__error),
  initDownload: getSrc(ASSET__initDownload),
  initPing: getSrc(ASSET__initPing),
  initUpload: getSrc(ASSET__initUpload),
  letsGetReady: getSrc(ASSET__letsGetReady),
  loading: getSrc(ASSET__loading),
  logo: getSrc(ASSET__logo),
  logos: {
    speedAnalyzerBig: getSrc(ASSET__logos__speedAnalyzerBig),
    speedAnalyzerSmall: getSrc(ASSET__logos__speedAnalyzerSmall),
    speedAnalyzerSmallGray: getSrc(ASSET__logos__speedAnalyzerSmallGray),
  },
  menu: getSrc({ bottomBar: getSrc(ASSET__menu__bottomBar) }),
  ok: getSrc(ASSET__ok),
  shield: getSrc(ASSET__shield),
  visonum: getSrc(ASSET__visonum),
  visonumLogo: getSrc(ASSET__visonumLogo),
  warning: getSrc(ASSET__warning),
  wave: getSrc(ASSET__wave),
  waveGray: getSrc(ASSET__waveGray),
};
